import Vue from 'vue'
import Router from 'vue-router'
import navHeader from '@/view/protocols/compnents/nav-header.vue'
Vue.use(Router)

export const constantRoutes = [

  {
    path: '/',
    component: () => import('@/view/Index/index')
  },
  {
    path: '/about-us',
    component: navHeader,
    hidden: true,
    children: [
      {
        path: '/about-us',
        component: () => import('@/view/protocols/about-us')
      }
    ]
  },
  {
    path: '/brand',
    component: navHeader,
    hidden: true,
    children: [
      {
        path: '/brand',
        component: () => import('@/view/protocols/brand')
      }
    ]
  },
  {
    path: '/solution',
    component: navHeader,
    hidden: true,
    children: [
      {
        path: '/solution',
        component: () => import('@/view/protocols/solution')
      }
    ]
  },
  {
    path: '/increment',
    component: navHeader,
    hidden: true,
    children: [
      {
        path: '/increment',
        component: () => import('@/view/protocols/increment')
      }
    ]
  }
]
const createRouter = () => new Router({
  mode: 'history', // /login/ /testnew/require service support
  base: '/',
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.onError(function(error) {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

// 设置路由拦截
router.beforeEach(function(to, from, next) {
  /* if (to.path =='/tutorial/index'||to.path == '/agreement'||to.path =='/login'||to.path =='/') {
    next()
   }else{
  if (!getLocalStorage('zsm-login')||!getLocalStorage('zsm-mobile')||!getLocalStorage('zsm-userInfo')||!getLocalStorage('zsm-versions')) {
    if (to.path !== '/login'||to.path !== '/') {
      removeToken('zsm-token')
      // removeToken('zsm-mobile')
      clearLocalStorage()
      return next('/')
      // return next('/login')
      // return next('/home')
    }
  }
  }*/
  next()
})
export default router
